// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"129":"80ba5cd3","778":"4e7d30f0"}[chunkId] + ".chunk.js";
};